import { gql } from "@apollo/client";

export const GET_ADDRESS = gql`
	query GetAddress {
		myAddress(first: 3) {
			nodes {
				id
				firstName
				lastName
				addressLine1
				addressLine2
				city
				zipCode
				stateId
				dateOfBirth
				phone
				countryId
				state {
					name
					code
				}
				country {
					name
				}
			}
		}
	}
`;
